import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccessGroup, AccessGroupRule } from '../../../../models/scan-testing.model';

// Picks a reusable Access Group to apply to a gate. Groups are defined in the
// Access Group manager; this modal only selects one of them.
@Component({
  selector: 'app-sr-access-group-modal',
  templateUrl: './sr-access-group-modal.component.html',
  standalone: false,
  styleUrls: ['./sr-modal-shared.scss']
})
export class SrAccessGroupModalComponent implements OnInit {
  @Input() initial?: AccessGroupRule;
  @Input() accessGroups: AccessGroup[] = [];
  @Output() confirmed = new EventEmitter<AccessGroupRule>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() manageGroups = new EventEmitter<void>();

  searchText = '';
  selectedGroupId: string | null = null;

  ngOnInit(): void {
    this.selectedGroupId = this.initial?.groupId ?? null;
  }

  filteredGroups(): AccessGroup[] {
    const q = this.searchText.trim().toLowerCase();
    if (!q) { return this.accessGroups; }
    return this.accessGroups.filter((g) => g.name.toLowerCase().includes(q));
  }

  select(group: AccessGroup): void {
    this.selectedGroupId = group.id;
  }

  onManageGroups(): void {
    this.manageGroups.emit();
  }

  onConfirm(): void {
    if (!this.selectedGroupId) { return; }
    this.confirmed.emit({ type: 'access_group', groupId: this.selectedGroupId });
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  trackGroup(_idx: number, group: AccessGroup): string { return group.id; }
}
